export const list = [
  {
    title: '赛码网有哪几种购买方式？',
    content:
      '赛码网支持体验试用，同时提供了多个版本套餐的购买，请根据您的用量和功能需求适当选择购买。笔试产品和面试产品是需要分别采购的呦。如需大额购买和定制需求，请直接联系客服获取报价。'
  },
  {
    title: '如果购买是否提供发票？',
    content:
      '可开具增值税电子/普通发票或增值税专用发票，若需要请直接联系我们。注意，请务必用公司的账户汇款给我们，才能开公司的发票。如果用个人账户汇款给我们，只能开个人的发票。'
  },
  {
    title: '赛码网都有哪些支付方式？',
    content: '我们接受银行对公转账汇款，支付宝转账，微信支付三种方式。'
  },
  {
    title: '如果购买会员是否可以签署相关合同？',
    content: '如果需要和我们签署服务合同，可以联系我们销售部了解合同内容。'
  },
  {
    title: '关于付费账号到期的相关问题？',
    content:
      '赛码网不管是还是付费用户，所有资料一经上传，都会一直保存。付费版到期后，账户余额将会被冻结，但是您可以继续使用其他功能。续费后可以解冻余额继续使用。'
  },
  {
    title: '发现已付费会员功能不够用，可以再升级吗？',
    content:
      '当然可以，您可以直接购买更高级的版本，享用高级别的会员功能和对应的额度用量。'
  },
  {
    title: '首冲优惠可以多次使用吗？',
    content:
      '不可以，首冲特惠仅限于您第一次付费购买才能享受到的特价，后续的购买就要按照产品标准价来进行消费啦。如有任何疑问，可以联系客服咨询。'
  }
]



// WEBPACK FOOTER //
// ./src/components/tariff/bottom-desc/config.js